<ng-template #modalLG let-modal style="border-radius: 8px">


    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style=" margin: 52px 64px 64px;">
        <div class="pt-2 text-center " style="margin-bottom: 24px">
            <h4 style="font-size: 24px">Envoyez par e-mail</h4>
            <p class="text-muted" style="font-size: 15px">Remplissez les informations nécessaires pour envoyer l’e-mail.</p>
        </div>

        <div class="modal-body p-0" tabindex="0" ngbAutofocus>

            <div class="modal-body flex-grow-1 p-0">
                <form #emailForm="ngForm" (ngSubmit)="sendEmail()">
                    <div class="items ">

                        <div class="flex-grow-1">

                            <div class="items2">
                                <!-- To -->
                                <input type="text"
                                       [(ngModel)]="email.to"
                                       placeholder="à :"
                                       name="recipient"
                                       class="w-full  "
                                       style="border: none ; width: 100%"/>

                            </div>
                            <hr style="margin-bottom: 24px">
                            <div class="items2">
                                <input type="email"
                                       [(ngModel)]="email.cc"
                                       placeholder="cc :"
                                       name="cc"
                                       class="w-full test2 "
                                       style="border: none ; width: 100%"/>

                            </div>
                            <hr style="margin-bottom: 24px">
                            <div class="items2" style="margin-bottom: 24px">
                                <div class="compose-mail-form-field" >

                                    <input
                                            type="text"
                                            id="emailSubject"
                                            class="w-full test2 "
                                            placeholder="Subject"
                                            name="emailSubject"
                                            [(ngModel)]="emailData.subject"

                                    />
                                </div>
                                <hr style="margin-bottom: 24px">
                            </div>

                            <div class="flex mb-0 " style="height: 30px ; text-align: start; ">
                                <button type="button" class="unstyled-btn ml-2" (click)="format('bold')"><i data-feather="bold" [size]="18" ></i></button>
                                <button type="button" class="unstyled-btn ml-2" (click)="format('italic')"> <i data-feather="italic" [size]="18" ></i></button>
                                <button type="button" class="unstyled-btn ml-2" (click)="format('underline')"><i data-feather="underline" [size]="18" ></i></button>
                                <button type="button" class="unstyled-btn ml-2" (click)="format('insertUnorderedList')"><i data-feather="list" [size]="18" ></i></button>
                                <button type="button" class="unstyled-btn ml-2" (click)="format('justifyLeft')"><i data-feather="align-left" [size]="18" ></i></button>
                                <button type="button" class="unstyled-btn ml-2" (click)="format('justifyCenter')"><i data-feather="align-center" [size]="18" ></i></button>
                                <button type="button" class="unstyled-btn ml-2" (click)="format('justifyRight')"><i data-feather="align-right" [size]="18" ></i></button>
                            </div>

                            <hr class="mt-0">
                            <div class="items2">
                                <!-- Default message -->
                                <div style=" margin-bottom: 24px;  height: 100px" class="blueContainer">
                                    <label  style="padding-left: 24px; padding-right: 24px; font-size: 15px; padding-top: 8px">
                                        Cher, Merci pour votre confiance. Votre document peut être visualisé,
                                        imprimé et téléchargé au format PDF à partir de la pièce jointe.
                                        Référence : {{reference}} Date : {{date}} Total : {{total}} </label>
                                </div>

                                <div
                                        contenteditable="true"
                                        #editor
                                        (input)="onContentChange(editor.innerHTML)"
                                        class="form-control textarea-like"
                                        data-placeholder="Ajoutez un message">
                                </div>

                            </div>
                        </div>
                    </div>

                    <!--    <div class="compose-footer-wrapper">
                            <div class="btn-wrapper d-flex align-items-center">

                                <div class="email-attachement">
                                    <label for="file-input">
                                        <i data-feather="paperclip" width="17" height="17" class="ml-50"></i>
                                    </label>
                                    <input id="file-input" type="file" class="d-none" multiple (change)="onFileChange($event)" />
                                </div>
                            </div>

                        </div>-->

                    <!-- Custom message -->

                </form>
            </div>
        </div>

        <div class="centerButtons">
            <button type="submit" class="btn btn-primary"
                    rippleEffect
                    (click)="sendEmail()"
                    [disabled]="!email.to || email.to.trim() === ''">
                Envoyer
            </button>
            <button type="button" class="btn" (click)="modal.close('Accept click')" rippleEffect style="background: rgba(128, 131, 144, 0.16)">
                Fermer
            </button>
        </div>
    </div>
</ng-template>
